import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import './main/ComponentInjector.ts';
import reportWebVitals from './reportWebVitals';

// Get the container element
const container = document.getElementById('root');

// Ensure the container is not null and create the root
if (container) {
  console.log('Root container not found')
  const root = createRoot(container);

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error('Root container not found');
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
